<template>
  <div>

    <div class="col-12">
      <div class="card mb-4">


        <div style="text-align: right; ">
            <b-button 
               variant="outline-primary"    
              @click="toggleFullLayout"
             size="sm"
            >
            <feather-icon
            icon="Maximize2Icon"
            size="12"
          />
          
          </b-button>
        </div>

        <div class="card-header">
          <h4 class="card-title">
            <span>{{RelName}}</span>
          </h4>
     
          <b-col v-if="showFiltro ? false : true ">
            <div style="float:right">
              <div class="DivBotaoLadoLado" >
              <b-button variant="danger" @click="$router.push('../Relatorios')">
                   <span>RETORNAR</span>
               </b-button>
              </div>
               
               <div class="DivBotaoLadoLado" >
               <b-button v-b-toggle="'collapse-filtro'" variant="primary" >
                 <span>FILTROS</span>
               </b-button>
               </div>
            </div>
          </b-col>

        </div>

        <b-collapse visible  id="collapse-filtro">
        <div class="card-body">

          <b-row>
            
            <b-col md="12" xl="12" class="mb-1">
             <b-form-group label="Produto:" >

                 <multiselect
                   v-model="CodProd"
                   placeholder="Selecione"
                   label="name"
                   track-by="code"
                   :options="CodProdOption"
                   :multiple="false"
                   :taggable="false"
                   :close-on-select="true"
                   :option-height="50"
                   :show-labels="false"
                 ></multiselect>

             </b-form-group>
           </b-col>



          </b-row>

         <b-row>
          <b-col md="12" xl="12" class="mb-1">
              <b-form-group label="Grupo:" >

                  <multiselect
                    v-model="CodGrupoProd"
                    placeholder="Selecione"
                    label="name"
                    track-by="code"
                    :options="CodGrupoProdOption"
                    :multiple="false"
                    :taggable="false"
                    :close-on-select="true"
                    :option-height="50"
                    :show-labels="false"
                  ></multiselect>

              </b-form-group>
            </b-col>

          </b-row>


        <b-row>
            


        <b-col
                md="6"
                xl="12"
                class="mb-1"
              >
              <div class="DivBotaoLadoLado" >
               <b-button
              variant="danger"
              type="button"
              @click="$router.push('../Relatorios')"
            >
              <span>RETORNAR</span>
            </b-button>
              </div>

              <div class="DivBotaoLadoLado" >
            <b-button v-b-toggle="'collapse-filtro'"
              variant="primary"
              type="submit"
              @click="ConsultarRelatorio"
            >
              <span>CONSULTAR</span>
            </b-button>
              </div>
              
          </b-col>


         </b-row>
         
        </div>
        </b-collapse>
        
      </div>
    </div>


      
    <div class="col-12" v-if="TabRelatorioPosition >= 0">
            <div class="card mb-4">
              <div class="card-body pb-60" >
                
                
              <div v-if="TabRelatorioPosition == 0">
                
                <div id="TabRelatorio">

                <h4 class="fw-bolder mb-1">Detalhe</h4>  
                 <b-table
                  striped
                  hover
                  responsive
                  small
                  sticky-header
                  :items="TabRelatorio"
                  :fields="visibleFields"
                  table-class = "font-size11"
                  thead-class = "font-size11"
                  thead-tr-class = "font-size11"
                  
                  
                >


                <template #cell(PCT_CX)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(PESOLIQPCT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>
               

                 <template #cell(CONFCX_KG)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(PESOLIQ)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(PESOBRUTO)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                 <template #cell(DECVLR)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(DECQTD)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(QTD_CX_PLT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                 <template #cell(LARG_PLT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(ALTU_PLT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(COMPR_PLT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(ALTU_TOTALCX)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(CUBAGEM)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(PESO_LQ_PLT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                 <template #cell(PESO_BT_PLT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                 <template #cell(LARGURACX)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>
      

                 <template #cell(ALTURACX)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(COMPRIMENTOCX)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(CUBAGEM_CX)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(LARG_PCT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>

                 <template #cell(ALTU_PCT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                 <template #cell(COMPR_PCT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                 <template #cell(PESO_PCT)="row">
                      {{ TextFormat(row.value,'money') }}
                 </template>


                </b-table>
                </div>

                <div class="col-2" style="float:right">
                   <b-form-group
                      label="">
                      <b-form-select
                      v-model="exportarParaSelected"
                      :options="exportarParaOptions"
                      @change="ExportarDoc('TabRelatorio','')"
                      >
                      </b-form-select>
                   </b-form-group>
                </div>

                
              </div>
               

             </div>
            </div>
    </div>



  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import VueApexCharts from 'vue-apexcharts'
import 'bootstrap-icons/font/bootstrap-icons.css'
import apiPortalSky from '@/services/apiPortalSky'
import AlertaMsg from '@/customPortal/AlertaMsg.vue'

import Spinner from '@/components/Spinner.vue'
import UtilVUE from '@/customPortal/UtilVUE.vue'

import {
  BFormGroup,
  BRow,
  BCol,
  BButton,
  BTable,
  BFormSelect,
  BFormInput,
  BCollapse,
  BCard,
  VBToggle,
  BFormDatepicker,
} from 'bootstrap-vue'

export default {
  components: {
    VueApexCharts,
    Multiselect,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    BTable,
    BFormSelect,
    BFormInput,
    BCollapse,
    BCard,
    BFormDatepicker,
  },
  directives: { 'b-toggle': VBToggle },
  data() {
    return {
      showFiltro: true,
      FiltroRelatorio: [],
      RelName: '',
      RelRota: '',
      TipoConsulta: '',
      TabRelatorio: [],
      TabRelatoriofields: [],
      
      CodProd: [],
      CodProdOption: [],
      CodGrupoProd: [],
      CodGrupoProdOption: [],
      exportarParaSelected: 'Exporte',
      exportarParaOptions: [
        { value: 'Exporte', text: 'Exporte' },
        { value: 'XLSX', text: 'Excel' },
      ],
      TabRelatorioPosition: -1,
    }
  },
  methods: {
    async MostraReport() {
      let notification = ""
      Spinner.StarLoad()
      const usuario = this.$session.get('usuario')
      
      let ParametroJson = ""
      let URLpost = `/Report/MostraReport?CODUSU=${usuario.codusu}&ROTA=${this.RelRota}`
      await apiPortalSky.post(URLpost, ParametroJson).then(response => {
        if (response.status === 200) {
          if (response.data != null) {
            this.RelName = response.data.descricaoRelatorio
          } else {
            notification = AlertaMsg.FormataMsgFiltroSemRetorno()
            AlertaMsg.FormataMsg(notification)
          }
        }
      }).catch(error => {
        notification = AlertaMsg.FormataMsgAPIError(error)
        AlertaMsg.FormataMsg(notification)
      })

      if(notification === '') {
       Spinner.EndLoad()
      }

    },
    async ConsultarOpcoes() {
      let notification = ""
      Spinner.StarLoad()
      const usuario = this.$session.get('usuario')

      if(notification === '') {
       
       let ParametroJson = ""
       let URLpost = `/Opcoes/ConsultaOpcoes?CODUSU=${usuario.codusu}&OPCAO=ProdutoGeral&ATIVO=S`
       await apiPortalSky.post(URLpost, ParametroJson).then(response => {
         if (response.status === 200) {
           if (response.data.length > 0) {
             this.CodProdOption = response.data
           } else {
             notification = AlertaMsg.FormataMsgFiltroSemRetorno()
             AlertaMsg.FormataMsg(notification)
           }
         }
       }).catch(error => {
         notification = AlertaMsg.FormataMsgAPIError(error)
         AlertaMsg.FormataMsg(notification)
       })
       
       }


       if(notification === '') {
        
        let ParametroJson = ""
        let URLpost = `/Opcoes/ConsultaOpcoes?CODUSU=${usuario.codusu}&OPCAO=TabPrecoGrupo1`
        await apiPortalSky.post(URLpost, ParametroJson).then(response => {
          if (response.status === 200) {
            if (response.data.length > 0) {
              this.CodGrupoProdOption = response.data
            } else {
              notification = AlertaMsg.FormataMsgFiltroSemRetorno()
              AlertaMsg.FormataMsg(notification)
            }
          }
        }).catch(error => {
          notification = AlertaMsg.FormataMsgAPIError(error)
          AlertaMsg.FormataMsg(notification)
        })
        
        }

       

      if(notification === '') {
       Spinner.EndLoad()
      }

    },
    async ConsultarRelatorio() {
      Spinner.StarLoad()

      //Inicio Dados Base Relatorio
      this.showFiltro = false
      const usuario = this.$session.get('usuario')
      let notification = ""
      this.FiltroRelatorio = []
      //Fim Dados Base Relatorio

      //Inicio Limpa Dados Retorno
      this.TabRelatorio = []
      
      // Fim Limpa Dados Retorno
      
      //Inicio Volta Todos Niveis para posição inicial
      this.TabRelatorioPosition = 0
      //Fim Volta Todos Niveis para posição inicial


      //Inicio Pega parametros de Parametros
   
      if(this.CodProd != null){
        if(Array.isArray(this.CodProd) == false)
        {
          const Filtro = {
            parametro: 'CODPROD',
            valor: this.CodProd.code,
          }
          this.FiltroRelatorio.push(Filtro)
        }
      }



      if(this.CodGrupoProd != null){
        if(Array.isArray(this.CodGrupoProd) == false)
        {
          const Filtro = {
            parametro: 'CODGRUPOPROD',
            valor: this.CodGrupoProd.code,
          }
          this.FiltroRelatorio.push(Filtro)
        }
      }



      //Fim Pega parametros de Parametros
      

      let ParametroJson = ''
      let URLpost = ''
      

    if(notification === '') {
      ParametroJson = JSON.parse(JSON.stringify(this.FiltroRelatorio))
      URLpost = `/Report/ExecutaRelDadosProdutosVenda?CODUSU=${usuario.codusu}`
      await apiPortalSky.post(URLpost, ParametroJson).then(response => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            this.TabRelatorio = response.data

            this.CustomFields()
            
          } else {
            notification = AlertaMsg.FormataMsgFiltroSemRetorno()
            AlertaMsg.FormataMsg(notification)
            
          }
        }
      }).catch(error => {
        notification = AlertaMsg.FormataMsgAPIError(error)
        AlertaMsg.FormataMsg(notification)
        
      })

    }



     if(notification === '') {
       Spinner.EndLoad()
     }

    },
    CustomFields() {
      
     
      this.TabRelatoriofields = [
       { key: 'CODPROD', label: 'Cód Produto', visible: true, sortable: false,tdClass: 'td100' },
       { key: 'REFERENCIA', label: 'Cód Nota Fiscal', visible: true, sortable: false,tdClass: 'td100' },
       { key: 'AD_CODESTRAPOLO', label: 'Cód Estruturado', visible: true, sortable: false,tdClass: 'td100' },
       { key: 'DESCRPROD', label: 'Produto', visible: true, sortable: false,tdClass: 'td300' }, 
       { key: 'CODVOL', label: 'Unid. Padrão Produto', visible: true, sortable: false,tdClass: 'td10' }, 
       { key: 'COMPLDESC', label: 'Apresentação(Qtde Cx Pct)', visible: true, sortable: false,tdClass: 'td100' }, 
       { key: 'PCT_CX', label: 'Pacotes p/ Cx', visible: true, sortable: false,tdClass: 'td50' }, 
       { key: 'PESOLIQPCT', label: 'Peso líq (Pct)', visible: true, sortable: false,tdClass: 'td50' }, 
       { key: 'CONFCX_KG', label: 'Conferencia em Kg (Cx)', visible: false, sortable: false,tdClass: 'td50' }, 
       { key: 'PESOLIQ', label: 'Peso líq. (Cx)', visible: true, sortable: false,tdClass: 'td50' }, 
       { key: 'PESOBRUTO', label: 'Peso bruto (Cx)', visible: true, sortable: false,tdClass: 'td50' }, 
       { key: 'PRAZOVAL', label: 'Validade (Dias)', visible: true, sortable: false,tdClass: 'td50' },

       { key: 'CODGRUPOPROD', label: 'Cod Grupo Produto', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'DESCR', label: 'Grupo Produto', visible: true, sortable: false,tdClass: 'td150' },


       { key: 'CODGPROD', label: 'Cod. Grupo Produção', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'DESCRGPROD', label: 'Grupo Produção', visible: true, sortable: false,tdClass: 'td150' },


       { key: 'NCM', label: 'NCM', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'CODREGMAPA', label: 'Cod M.A.P.A', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'DECVLR', label: 'Decimal p/ Valor', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'DECQTD', label: 'Decimal p/ Quantidade', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'EAN', label: 'Cod Barras Pct EAN', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'UNIDALT', label: 'Unidade Alternativa', visible: false, sortable: false,tdClass: 'td50' },
       { key: 'DUM', label: 'Cod Barras Cx DUM', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'QTD_CX_PLT', label: 'Caixas p/ Pallet', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'LASTRO', label: 'Lastros', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'CAMADAS', label: 'Camadas', visible: true, sortable: false,tdClass: 'td50' },

       { key: 'CODPRODPI', label: 'Cod Produto (PI)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'DESCRPRODPI', label: 'Produto (PI)', visible: true, sortable: false,tdClass: 'td300' },

       { key: 'CODCX', label: 'Cod Caixa', visible: true, sortable: false,tdClass: 'td30' },
       { key: 'SKUCX', label: 'SKU Caixa', visible: true, sortable: false,tdClass: 'td30' },
       { key: 'DESCRCX', label: 'Descrição Caixa', visible: true, sortable: false,tdClass: 'td300' },
       { key: 'LARG_PLT', label: 'Largura Pallet', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'ALTU_PLT', label: 'Altura Pallet', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'COMPR_PLT', label: 'Comprimento Pallet', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'ALTU_TOTALCX', label: 'Altura Total Pallet', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'CUBAGEM', label: 'Cubagem Pallet', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'PESO_LQ_PLT', label: 'Peso Liq SKU p/ Pallet', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'PESO_BT_PLT', label: 'Peso Bruto SKU p/ Pallet', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'LARGURACX', label: 'Largura (Cx)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'ALTURACX', label: 'Altura (Cx)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'COMPRIMENTOCX', label: 'Comprimento (Cx)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'CUBAGEM_CX', label: 'Cubagem (Cx)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'LARG_PCT', label: 'Largura (Pct)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'ALTU_PCT', label: 'Altura (Pct)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'COMPR_PCT', label: 'Comprimento (Pct)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'PESO_PCT', label: 'Peso (Pct)', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'PERCENTUAL_PIS', label: 'Percentual PIS', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'PERCENTUAL_COFINS', label: 'Percentual CONFINS', visible: true, sortable: false,tdClass: 'td50' },
       { key: 'PERCENTUAL_ICMS', label: 'Percentual ICMS', visible: true, sortable: false,tdClass: 'td50' },

       
              
      ]
     

      
      
    },
    TextFormat(valor, tipo) {
      return UtilVUE.TextFormat(valor, tipo)
    },
    ExportarDoc (ElementToExport,DocName) {
      let DataExport = ""
      switch (ElementToExport) {
                case 'TabRelatorio':
                DataExport = this.TabRelatorio
                DocName = 'RelDadosProdutosVenda'
                break
      }    
      UtilVUE.ExportDoc(this.exportarParaSelected,DocName,ElementToExport,DataExport)
      this.exportarParaSelected = 'Exporte'
      return

    },
    toggleFullLayout() {
      UtilVUE.toggleFullLayout(this.$router, this.$route);
    }
  },
  computed: {
    visibleFields() {
        return this.TabRelatoriofields.filter(field => field.visible)
      }
  },
  mounted() {
    if (this.$route.name != null) {
      this.RelRota = this.$route.name
      this.MostraReport()
      this.ConsultarOpcoes()
    }
  },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
